import React, { useRef, useEffect, useLayoutEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import './TopAnimation.scss';

const MAX_BUBBLE_SIZE = 420;
const MAX_BUBBLE_SIZE_MOBILE = 420;

const TopAnimation = React.forwardRef(({ isTopicSelected, introData, sectionHeight, sectionWidth, onAnimationEnd, mainBubbleSizeSetter, onMobile }, theRef) => {
  const [animated, setAnimated] = useState(false);
  const [bubbleSize, setBubbleSize] = useState(0);
  const mediaPath = useSelector(state => state.config.basePath + state.config.apiMediaPath);
  const refContent = useRef(null);
  const refTitle = useRef(null);
  const refSubtitle = useRef(null);
  const refSize = useRef(9999999);

  useEffect(() => {
    const size = onMobile ? Math.min(MAX_BUBBLE_SIZE_MOBILE, sectionWidth * 0.4) : Math.min(MAX_BUBBLE_SIZE, sectionWidth / (introData.AnimationImages.length - 1) * 2);
    refSize.current = size;
    setBubbleSize(size);
    mainBubbleSizeSetter(size);
  }, [sectionWidth, onMobile]);

  useLayoutEffect(() => {
    if (refContent.current && refSubtitle.current) {
      const margin = 20;
      const contentRect = refContent.current.getBoundingClientRect();
      const subtitleRect = refSubtitle.current.getBoundingClientRect();
      const availableSpace = (contentRect.top + contentRect.height / 2) - (subtitleRect.top + subtitleRect.height) - margin;
      if (availableSpace < refSize.current / 2) {
        refSize.current = availableSpace * 2;
        setBubbleSize(availableSpace * 2);
        mainBubbleSizeSetter(availableSpace * 2);
      }
    }

    setTimeout(() => {
      setAnimated(true);
      setTimeout(() => {
        if (onAnimationEnd) onAnimationEnd();
      }, 800);
    }, 750);
  }, []);

  const animationImages = onMobile ? introData.AnimationImagesMobile : introData.AnimationImages;

  return (
    <div className="innovation-top-animation" ref={theRef} aria-hidden={isTopicSelected? "true":"false"} >
      <div className="cpvi-grid-container">
        <div className="cpvi-grid-row">
          <div className="cpvi-grid-col w12">
            <div className="innovation-ta-content-holder" style={{ height: `${sectionHeight}px`}} ref={refContent}>
              <div className="innovation-ta-anim-wrapper" style={{ width: `${sectionWidth}px` }}>
              {
                animationImages.map((image, i) => (
                  onMobile && i > 6
                  ?
                  null
                  :
                  <div
                    key={i}
                    className={`innovation-ta-circle ${ animated ? 'end-position' : '' }`}
                    style={
                      onMobile
                      ?
                      {
                        width: animated ? `${bubbleSize}px` : `${sectionWidth * 0.75}px`,
                        left: animated ? '50%' : `${ i === 0 ? 50 : (sectionWidth / 2 + (sectionWidth * 0.75 * 0.9) * Math.cos(Math.PI / 3 * (i - 1))) / sectionWidth * 100}%`,
                        top: animated ? '50%' : `${ i === 0 ? 50 : (sectionHeight / 2 - (sectionWidth * 0.75 * 0.9) * Math.sin(Math.PI / 3 * (i - 1))) / sectionHeight * 100}%`
                      }
                      :
                      {
                        width: `${bubbleSize}px`,
                        left: animated ? '50%' : `${ i * (100 / (animationImages.length - 1))}%`
                      }
                    }
                  >
                    <div
                      className="innovation-ta-circle-inner"
                      style={{
                        backgroundImage: `url(${mediaPath + animationImages[i].Image})`
                      }}
                    />
                  </div>
                ))
              }
              </div>
              <div className="innovation-ta-title-holder">
                <div
                  className={`innovation-ta-title ${ animated ? 'end-position' : ''}`}
                  style={ animated || onMobile ? { top: `${ 70 / sectionHeight * 100}%` } : null}
                  ref={refTitle}
                >{introData.SectionTitle}</div>
                <div
                  className={`innovation-ta-subtitle ${ animated ? 'end-position' : ''}`}
                  style={{ top: `${ (70 + (onMobile ? 30 : 50)) / sectionHeight * 100}%` }}
                  ref={refSubtitle}
                >{introData.SectionSubtitle}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
});

export default TopAnimation;